import { render, staticRenderFns } from "./TestButton.vue?vue&type=template&id=63edcc93&"
import script from "./TestButton.vue?vue&type=script&lang=js&"
export * from "./TestButton.vue?vue&type=script&lang=js&"
import style0 from "./TestButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports